import Vue, { ref, VNode } from 'vue';
import { iconClassEnum } from '../enums/iconClassEnum';
import i18n from '../locales/i18n';

export const useModal = () => {
  const isVisible = ref(false);

  const show = () => {
    isVisible.value = true;
  };
  const hide = () => {
    isVisible.value = false;
  };
  const toggle = () => {
    isVisible.value = !isVisible.value;
  };

  const showWarning = (message: VNode[] | string, proxy: Vue) => {
    const iconClose = `<i class="${iconClassEnum.CLOSE}"></i>`;

    return proxy.$bvModal.msgBoxOk(message, {
      size: 'sm',
      modalClass: 'modal-warning',
      okVariant: 'primary',
      title: i18n.t('label.warning').toString(),
      okTitle: i18n.t('button.ok').toString(),
      hideHeaderClose: false,
      headerCloseContent: iconClose,
    });
  };

  return {
    isVisible,
    show,
    hide,
    toggle,
    showWarning,
  };
};
